import React from "react";
import { string, object, bool } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { generateNavigateSlug, navigateTo } from "../../utils";
import { DfpComponent } from "../../ads/dfp-component";
import "./collection-title.m.css";

export default function CollectionTitle({
  collection,
  enableSponsorAd,
  sponsorAdDetails,
  config = {},
  styles,
  hideTitle,
  containerStyles,
  sectionSlug,
  sponsorAdConfig,
}) {
  const dispatch = useDispatch();
  const qtConfig = useSelector((state) => get(state, ["qt", "config"], {}));
  const url = generateNavigateSlug(collection, qtConfig);

  const selectedSectionPage = (sectionSlug) => {
    switch (sectionSlug) {
      case "friday":
      case "your-money":
      case "parenting":
      case "best-buys":
      case "living-in-uae":
      case "videos":
        return true;
      default:
        return false;
    }
  };

  const selectedSectionpPage = selectedSectionPage(sectionSlug);
  const sectionPageStyle = { fontFamily: "var(--secondary-font)", fontWeight: "var(--bold)" };

  const customUrlPath = collection?.metadata?.["collection-display-url"] || "";
  let collectionDisplayName = collection?.metadata?.["collection-display-name"] || collection?.name;
  const slug = customUrlPath ? customUrlPath : generateNavigateSlug(collection, { ...qtConfig, ...config });
  return (
    <Link href={slug} navigateTo={() => navigateTo(dispatch, url)}>
      <div styleName={`title-with-ad ${containerStyles || ""}`}>
        {!hideTitle && (
          <div styleName="collection-title">
            <p styleName={styles} style={selectedSectionpPage ? sectionPageStyle : null}>
              {collectionDisplayName}
            </p>
          </div>
        )}
        {enableSponsorAd && (
          <DfpComponent
            adStyleName="ad-slot-size-100x60"
            id={`${collection?.slug}-sponsor-ad`}
            path={sponsorAdDetails}
            size={sponsorAdConfig?.sizes}
            viewPortSizeMapping={sponsorAdConfig?.view_port_size_mapping}
          />
        )}
      </div>
    </Link>
  );
}

CollectionTitle.propTypes = {
  collection: object,
  enableSponsorAd: bool,
  sponsorAdDetails: string,
  config: object,
  containerStyles: string,
  styles: string,
  qtConfig: object,
  sponsorAdConfig: object,
  hideTitle: bool,
  sectionName: string,
};
